import { IShader } from './IShader';
import { ShaderProgram } from './ShaderProgram';
import { Matrix4 } from './Matrix4';
import { Filter } from './Filter';
import { ImageAdjustParams } from './ImageAdjustParams';
import { MaskParams } from './MaskParams';
import { Matrix3 } from './Matrix3';

export class EmptyShader implements IShader {
  program: ShaderProgram | null = null;

  constructor() {
    this.program = null;
  }

  dispose(): void {}

  setProjection(_value: Matrix4): void {}

  setImageAdjust(_imageAdjust: ImageAdjustParams): void {}

  setMask(_index: number, _params: MaskParams): void {}

  setTransform(_params: Matrix3): void {}

  setFilter(_filter: Filter): void {}
}
